import React, { useCallback, useEffect, useState } from "react";
import { axiosClient } from "../api/proxy/AxiosClient";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Grid2,
} from "@mui/material"; 
import Schedule from "./Schedule";
import UserList from "./UserList";

export default function CreateLessonByStudent({
  open,
  onClose,
  onSave,
  setNewLesson,
  users,
  selectedTeacher,
  scheduleRef
}) {
 
  const [name, setName] = useState("");
  const [comment, setComment] = useState("");
  const [fee, setFee] = useState(100);
  const [ccy, setCcy] = useState("USD");
  const [link, setLink] = useState("");
  const [localSchedule, setLocalSchedule] = useState(scheduleRef.current || { start: null, end: null });
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [localSelectedTeacher, setLocalSelectedTeacher] = useState(selectedTeacher || null);

  const user = JSON.parse(localStorage.getItem("user"));

  const [events, setEvents] = useState([]);

  const handleSave = async () => {
      onSave({
        name,
        studentUids: [user.uid],
        teacherUid: localSelectedTeacher?.uid,
        startDttm: localSchedule.start,
        endDttm: localSchedule.end,
        fee: parseFloat(fee),
        ccy,
        link,
        comment
      }).then((newLessonResponse) => {
        setNewLesson(newLessonResponse.data);
        onClose();
        setName("");
        setFee(0);
        setCcy("USD");
        setLink("");
        setLocalSchedule({ start: null, end: null });
      }).catch (err => {
        console.error(err.message);
    });
  };

  const handleRangeSelected = (range) => {
    setLocalSchedule(range);
    scheduleRef.current = range;
    setScheduleModalOpen(false);
  };

  const fetchEvents = useCallback(async () => {
    try {
      const url = `/lessons?studentUid=${user.uid}${localSelectedTeacher ? `&teacherUid=${localSelectedTeacher?.uid}` : ''}`;
      const response = await axiosClient.get(url);
      const lessonRequests = response.data;

      const formattedEvents = lessonRequests.map((request) => ({
        id: request.id,
        uid: request.uid,
        title: request.uid ? `[${request.name}]` : '[]',
        start: new Date(request.startDttm),
        end: new Date(request.endDttm),
        status: request.status,
        allDay: false,
        lesson: request
      }));

      setEvents(formattedEvents);
    } catch (error) {
      console.error("Error fetching events:", error);
      return [];
    }
  }, [user?.uid, localSelectedTeacher]);

  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" keepMounted>
        <DialogTitle>Create Lesson</DialogTitle>
        <DialogContent dividers>
          <Grid2 container spacing={2}>
            <Grid2>

              <Box mb={2}>
                <TextField
                  label="Teacher"
                  fullWidth
                  value={`${localSelectedTeacher ? localSelectedTeacher.firstName + ' ' + localSelectedTeacher.lastName : ''}`}
                  disabled
                />
              </Box>

              <Box mb={2}>
                <TextField
                  label="Lesson Name"
                  fullWidth
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Box>

              <Box mb={2}>
                <TextField
                  label="Lesson Comment"
                  fullWidth
                  multiline
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </Box>

              <Box mb={2}>
                <TextField
                  label="From - Till"
                  fullWidth
                  value={
                      (localSchedule.start ? new Date(localSchedule.start).toLocaleString(undefined, {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false
                      }) : "--/--/---- --:--") +
                      " - " +
                      (localSchedule.end ? new Date(localSchedule.end).toLocaleTimeString(undefined, {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false
                      }) : "--:--")
                  }
                  onClick={() => setScheduleModalOpen(true)}
                  readOnly
                />
              </Box>

              <Box mb={2}>
                <TextField
                  label="Fee"
                  type="number"
                  fullWidth
                  value={fee}
                  onChange={(e) => setFee(e.target.value)}
                />
              </Box>

              <Box mb={2}>
                <TextField
                  label="Currency"
                  fullWidth
                  value={ccy}
                  onChange={(e) => setCcy(e.target.value.toUpperCase())}
                  slotProps={{ input: { maxLength: 3 } }}
                />
              </Box>

            </Grid2>
            <Grid2>
              <UserList
                users={users}
                multiselect={false}
                selectedUser={localSelectedTeacher}
                handleSelectedUser={setLocalSelectedTeacher}
              />
            </Grid2>
          </Grid2>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={scheduleModalOpen}
        onClose={() => setScheduleModalOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Select Schedule</DialogTitle>
        <DialogContent dividers>
          <Schedule
            start={localSchedule.start}
            end={localSchedule.end}
            onRangeSelected={handleRangeSelected}
            selectedUser={localSelectedTeacher}
            events={events}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setScheduleModalOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
